import React from "react";
import { useNavigate } from "react-router-dom";
import "./Post.css";

const Post = ({ title, text, image, id }) => {
  const navigate = useNavigate();

  const openPost = () => {
    navigate(`/aktualnosci/${id}`);
  }

  return (
    <div className="post-panel" onClick={openPost} >
      <h2 onClick={openPost} className="post-title" >{title}</h2>
      {image && <img onClick={openPost} src={image} alt={title} className="post-preview-image" />}
      <p onClick={openPost} className="post-preview-text" >{text}</p>
    </div>
  );
};

export default Post;
